<template>
  <div class="container container-table loginpage">
    <div class="row vertical-10p logincntrrow">
      <div class="container logincntr">
        <div class="text-center col-md-4 col-sm-offset-4 loginFormwrp">
          <div class="forcechange">
            <h2>Please change your password</h2>
               <div class="p-messagebubble">The new password must be 8 character, contain at least: 1 uppercase letter, 1 lowercase letter, 1 number, and one special character (E.g. , . _ & ? etc)</div>
             
             <div class="error loginModuleToperror"> <span v-show="errors.has('password')" class="help is-danger">{{ errors.first('password') }}</span><span class="error " v-show="errors.has('username')">{{ errors.first('username') }}</span></div>
               
            <form @submit.prevent="confirm" class="ui form loginForm">
              <div class="input-group" v-bind:class="errors.has('username') ? 'error' : ''">
                <span class="input-group-addon">
                  <i class="fa fa-user"></i>
                </span>
                <input class="form-control" type="text" placeholder="email" v-model="email" v-on:blur="validemail" name="username" v-validate="{ email: true }" >
              </div>
              <div class="input-group">
                <span class="input-group-addon">
                  <i class="fa fa-lock"></i>
                </span>
                <input type="password" class="validate form-control" placeholder="Old password" v-model="password" required>
              </div>
              <div class="input-group">
                <span class="input-group-addon">
                  <i class="fa fa-lock"></i>
                </span>
                <input v-validate="'required|min:8|verify_password'" data-vv-as="newpassword" name="newpassword" type="password" class="validate form-control" placeholder="New Password" v-model="newpassword" v-on:blur="validpassword" >
               
              </div>
            <div class="input-group forgetsubmit"> <span>If you are facing a issue, contact support on Yammer Group</span>
                <button type="submit" v-bind:class="'loginsubmit btn btn-primary btn-lg'">Submit</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import VeeValidate from 'vee-validate'
const config = {
  errorBagName: 'errors', // change if property conflicts.
  fieldsBagName: 'fields',
  delay: 0,
  locale: 'en',
  dictionary: null,
  strict: true,
  enableAutoClasses: true,
  classNames: {
    touched: 'touched', // the control has been blurred
    untouched: 'untouched', // the control hasn't been blurred
    valid: 'valid', // model is valid
    invalid: 'invalid', // model is invalid
    pristine: 'pristine', // control has not been interacted with
    dirty: 'dirty' // control has been interacted with
  },
  events: 'input|blur',
  inject: true
}

Vue.use(VeeValidate, config)
VeeValidate.Validator.extend('verify_password', {
  getMessage: field => `The password must contain at least: 1 uppercase letter, 1 lowercase letter, 1 number, and one special character (E.g. , . _ & ? etc)`,
  validate: value => {
    // eslint-disable-next-line
    var strongRegex = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})')
    return strongRegex.test(value)
  }
})
export default {
  name: 'Confirm',
  data () {
    return {
      email: '',
      password: '',
      newpassword: ''
    }
  },
  methods: {
    validpassword () {
      this.$validator.validate('newpassword', this.newpassword)
    },
    validemail () {
      this.$validator.validate('username', this.email)
      if (this.fields.username.valid) {
        var emailCorrecter = String(this.email)
        emailCorrecter = emailCorrecter.split('.')[0].charAt(0).toUpperCase() + emailCorrecter.split('.')[0].slice(1) + '.' + emailCorrecter.split('.')[1].charAt(0).toUpperCase() + emailCorrecter.split('.')[1].slice(1) + '.' + emailCorrecter.split('.')[2]
        this.email = emailCorrecter
      }
    },
    confirm () {
      var self = this
      this.$validator
        .validateAll()
        .then(function (response) {
          self.submitpassword()
        })
        .catch(function (e) {
          // Catch errors
        })
    },
    submitpassword () {
      var self = this
      // var emailCorrecter = String(this.email)
      // emailCorrecter = emailCorrecter.split('.')[0].charAt(0).toUpperCase() + emailCorrecter.split('.')[0].slice(1) + '.' + emailCorrecter.split('.')[1].charAt(0).toUpperCase() + emailCorrecter.split('.')[1].slice(1)
      // this.email = emailCorrecter
      this.$cognito.forceChangePassword(this.email, this.password, this.newpassword)
        .then(result => {
          self.$pingpong.hideloader()
          self.$router.replace('/login')
        })
        .then(err => {
          console.log(err)
          this.error = err
          // window.alert(err)
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.loginsubmit {
  position: relative;
}
.forgetsubmit {
  color: #444;
  width: 100%;

  text-align: right;
  display: block;
}
.forcechange h2 {
  color: #444;
  text-align: left;
  margin-bottom: 20px;
}

.forgetsubmit span {
  position: absolute;
  left: 0;
  display: inline-block;
  margin-top: 15px;
}
.logincntr {
  height: 457px;
}
.p-messagebubble {
  background-color: #d1f5ff;
  margin-bottom: 15px;
  padding: 10px;
  border: 1px solid #3fb1d2;
  color: #3fb1d2;
}
</style>




// WEBPACK FOOTER //
// ForceChangePassword.vue?c0d9ca34